import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import ReactDragListView from 'react-drag-listview';
import throttle from 'lodash/throttle';
import propTypes from 'prop-types';

import Table from '../table';
import style from './style.less';

const ResizeTable = forwardRef((props, ref) => {
  const [x, setX] = useState(0);
  const [y, setY] = useState(0);
  const tableRef = useRef('');
  //记录出事table高度
  const firstHeight = useRef(0);

  const setTableSize = () => {
    const tableContent = tableRef.current;
    if (!tableContent) {
      return;
    }

    const { pagination, defaultHeight } = props;
    const paginationHeight = pagination ? 64 : 0;
    const tableHead = tableContent.querySelector('.ant-table-thead');
    const table = tableContent.querySelector('.ant-table');
    // antd v3 用 .ant-table-content，antd v4 有 scroll 时用 .ant-table-body
    const tableSelfContent = tableContent.querySelector('.ant-table-content') ||
                             tableContent.querySelector('.ant-table-body');
    if (!tableHead || !table || !tableSelfContent) {
      return;
    }
    const { clientHeight } = tableHead;
    //修改数据过少右侧没有border（仅对 .ant-table-content 生效）
    if (tableSelfContent.classList.contains('ant-table-content') &&
        tableSelfContent.clientHeight < tableContent.clientHeight) {
      tableSelfContent.style.height = tableContent.clientHeight - paginationHeight + 'px';
    }
    const tableHeight = defaultHeight ? defaultHeight : tableContent.clientHeight;
    table.style.height = `${tableHeight - paginationHeight}px`;
    const y = tableHeight - clientHeight - paginationHeight;

    setX(tableContent.clientWidth);
    setY(y);
  };

  const resize = () => {
    throttle(() => {
      setTableSize();
    }, 600)();
  };

  useImperativeHandle(ref, () => ({
    setTableSize: setTableSize
  }));

  useEffect(() => {
    resize();
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, [props.dataSource]);

  const {
    pagination = {},
    rowSelection = {},
    dragSort = false,
    dragSelector = 'i',
    onDragEnd = () => {},
    fixed = false,
    dataSource,
    className = '',
    loading = false,
    rowKey = e => e.id,
    onRow = () => null
  } = props;

  const { selectedRowKeys } = rowSelection ?? {};
  const { renderPop } = pagination;
  const popShow = renderPop && selectedRowKeys && selectedRowKeys?.length > 0;

  // antd v4 中 scroll.y=0 会将 max-height 设为 0，需 y>0 才传入
  let scroll = y ? { y } : {};

  if (fixed) {
    scroll = { ...scroll, x };
  }

  // 增加高度让table吸顶
  useEffect(() => {
    if (!dataSource?.length) return;

    const { addHeightId } = props;
    if (addHeightId) {
      if (tableRef.current.clientHeight && !firstHeight.current) firstHeight.current = tableRef.current.clientHeight;
      const tableHeight = firstHeight.current || 0;
      const addDom = document.querySelector(addHeightId);
      let addHeight = addDom?.clientHeight ?? 0;
      if (addHeight > 10) addHeight -= 10;
      tableRef.current.style.height = addHeight + tableHeight + 'px';
    }
  }, [dataSource]);

  return (
    <div ref={tableRef} className={style.table}>
      {dragSort ? (
        <ReactDragListView onDragEnd={onDragEnd} handleSelector={dragSelector}>
          <Table {...props} scroll={scroll} />
        </ReactDragListView>
      ) : (
        <Table {...props} scroll={scroll} />
      )}
      {popShow ? <div className={style.pop}>{renderPop && renderPop(selectedRowKeys)}</div> : null}
    </div>
  );
});

ResizeTable.propTypes = {
  dataSource: propTypes.array,
  columns: propTypes.array,
  loading: propTypes.bool,
  className: propTypes.string,
  rowKey: propTypes.oneOfType([propTypes.string, propTypes.func]),
  fixed: propTypes.bool,
  pagination: propTypes.oneOfType([propTypes.object, propTypes.bool]),
  onRow: propTypes.func
};

export default ResizeTable;
